import React from "react";
import {withStyles} from "@material-ui/core/styles";
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";

export const ExpansionPanelSummary = withStyles({
  root: {
    backgroundColor: "#F2F2F2",
    border: "1px solid #CACCD1",
    marginBottom: -1,
    minHeight: 40,
    margin: 0,
    padding: 0,
    "& .MuiExpansionPanelSummary-content": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      margin: 0,
      "&  p": {
        fontSize: 14,
        color: "#00334E",
        marginLeft: "10px",
        marginTop: "3px"
      },
      "& svg": {
        fill: "#00334E"
      }
    },
    "&$expanded": {
      minHeight: 40
    }
  },
  content: {
    "&$expanded": {}
  },
  expanded: {}
})(MuiExpansionPanelSummary);

export default ExpansionPanelSummary;
